/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import { useIntl } from 'components/i18n';
import { VatCode} from '../types';
import getVatCodeName from '../getVatCodeName';

const defaultProps = {
  date: new Date()
};

type Props = {
  vatCode?: VatCode;
} & typeof defaultProps;

const VatCodeName = ({vatCode}: Props) => {
  const intl = useIntl();
  // return <React.Fragment>{vatCode?.displayName}</React.Fragment>;

  return <React.Fragment>
    {getVatCodeName({intl, vatCode})}
  </React.Fragment>;
};

export default VatCodeName;

VatCodeName.defaultProps = defaultProps;
